import { FC, ReactNode, useMemo } from "react";
import Page from "../../components/page/page";
import { Tabs, TabsList, TabsTrigger } from "../../components/ui";
import StorageSettingsTab from "./storage-settings-tab";
import UserSettingsTab from "./user-settings-tab";
import SubscriptionSettingsTab from "./subscription-settings-tab";
import AdminSettingsTab from "./admin-settings-tab";
import { useAuth } from "../../hooks/use-firebase";

type SettingsTabType = {
  label: string,
  value: string,
  tab: ReactNode,
  visible: boolean,
}

export const Settings: FC = () => {
  const auth = useAuth();

  // Check if current user is admin
  const isAdmin = useMemo(() => {
    return auth?.currentUser?.uid === process.env.REACT_APP_ADMIN_UID;
  }, [auth?.currentUser?.uid]);

  const settingTabs: SettingsTabType[] = useMemo(() => {
    return [
      {
        label: "Storage",
        value: "storage_settings",
        tab: <StorageSettingsTab />,
        visible: true,
      },
      {
        label: "User",
        value: "user_settings",
        tab: <UserSettingsTab />,
        visible: true,
      },
      {
        label: "Subscription",
        value: "subscription_settings",
        tab: <SubscriptionSettingsTab />,
        visible: true,
      },
      {
        label: "Admin",
        value: "admin_settings",
        tab: <AdminSettingsTab />,
        visible: isAdmin,
      },
    ].filter((i) => i.visible)
  }, [isAdmin])

  return (
    <Page title="Settings">
      <Tabs defaultValue="storage_settings" className="p-2">
        <TabsList>
          {settingTabs.map((i) => {
            return <TabsTrigger value={i.value} className="text-lg font-bold">
              {i.label}
            </TabsTrigger>

          })}
        </TabsList>
        <>
          {settingTabs.map((i) => {
            return i.tab
          })}
        </>
      </Tabs>
    </Page>
  )
}

